import React, { useState } from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTables from "./DataTables"
import MetaTag from "components/Common/Meta-tag"
import { map } from "lodash"
import useRole from "hooks/useRole"

function Members() {
  const [staffType, setStaffType] = useState("branchStaff")
  const { isSuperAdmin } = useRole()

  return (
    <>
      <MetaTag title={"All Staffs"} />

      <div className="page-content position-relative">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="All Staffs"
          isBranchFilter
        />

        <Container fluid style={{ marginTop: isSuperAdmin() ? "-60px" : "" }}>
          {isSuperAdmin() && (
            <div
              className="btn-group mt-0 mb-2 mt-xl-0 d-flex align-items-center justify-content-center"
              role="group"
              aria-label="Basic radio toggle button group"
              style={{ width: "fit-content", margin: "auto" }}
            >
              {map(
                [
                  {
                    id: 22,
                    title: "Branch Staff",
                    value: "branchStaff",
                  },
                  {
                    id: 33,
                    title: "HQ Staff",
                    value: "hqStaff",
                  },
                ],
                (item, key) => (
                  <div key={key} className="ms-2">
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio-staffType"
                      id={item.value + "staffType"}
                      autoComplete="off"
                      checked={staffType === item.value}
                      value={item.value}
                      onClick={e => {
                        const value = e.target.value
                        if (staffType?.includes(value) === true) {
                          setStaffType("")
                        } else {
                          setStaffType(value)
                        }
                      }}
                    />
                    <label
                      className="btn btn-md btn-outline-info"
                      htmlFor={item.value + "staffType"}
                    >
                      {item.title}
                    </label>
                  </div>
                )
              )}
            </div>
          )}
          <div className="container-fluid">
            <DataTables staffType={staffType} />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Members
